import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Category } from '../../../models/category/category.model';
import { DisplayCategory } from '../../../models/category/DisplayCategory.model';
import { CategoryService } from '../../../services/category/category.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../../services/role/role-permission.service';

@Component({
    selector: 'app-edit-parent-category',
    templateUrl: './edit-parent-category.component.html',
    styleUrls: ['./edit-parent-category.component.css']
})
/** edit-parent-category component*/
export class EditParentCategoryComponent {
  public category = new Category();
  fileToUpload: File;
  fd = new FormData();
  selectedTinyImage: string;
  selectedSmallImage: string;
  selectedLargeImage: string;
  public parentCategoryList: Category[];
  public categoryList: Category[];
  public isCategoryExist: boolean;
  public duplicateCategory: string;
  public websiteName: string;
  public htmlContent: any;
  configuration = {
    uiColor: '#ffffff',
    toolbarGroups: [{ name: 'clipboard', groups: ['clipboard', 'undo'] },
    { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
    { name: 'links' }, { name: 'insert' },
    { name: 'document', groups: ['mode', 'document', 'doctools'] },
    { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
    { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
    { name: 'styles' },
    { name: 'colors' }],
    resize_enabled: false,
    removePlugins: 'save',
    extraPlugins: 'smiley,justify,indentblock,colordialog',
    colorButton_foreStyle: {
      element: 'font',
      attributes: { 'color': '#(color)' }
    },
    height: 188,
    removeDialogTabs: '',
    removeButtons: '',
    format_tags: 'p;h1;h2;h3;pre;div'
  }
    /** edit-parent-category ctor */
  constructor(private _avRoute: ActivatedRoute,
    private categoryService: CategoryService,
    private _router: Router,
    private readonly toastr: ToastsManager, vcr: ViewContainerRef, private readonly rolePermissionService: RolePermissionService) {
    this.checkPermission();
    this.category.metaTitle = "";
    this.category.metaDescription = "";
    this.category.metaTag = "";
    this.category.justForU = false;
    this.toastr.setRootViewContainerRef(vcr);
    if (this._avRoute.snapshot.params["id"]) {
      this.getCategoryById(this._avRoute.snapshot.params["id"]);
      this.GetParentCategoryList();
      this.GetCategoryList();
      this.GetSystemSettingFirstOrDefault();
    }
  }
  checkPermission() {
    this.rolePermissionService.GetRolePermissions("parentcategory").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
           
          }
          else {
            this._router.navigate(["/Parent-Category-List"]);
          }
        }
        else {
          this._router.navigate(["/Parent-Category-List"]);
        }
      }
    )
  }


  getCategoryById(id: string) {
    this.categoryService.GetCategoryById(id).subscribe(
      data => {
        this.category = data;
        this.htmlContent = this.category.detail;
        if (this.category.metaTitle == "" || this.category.metaTitle ==null) {
          this.category.metaTitle = "";
        }
        if (this.category.metaDescription == "" || this.category.metaDescription ==null) {
          this.category.metaDescription = "";
        }
        if (this.category.metaTag == "" || this.category.metaTag ==null) {
          this.category.metaTag = "";
        }
      }
    )
  }
  GetParentCategoryList() {
    this.categoryService.GetCategoryList().subscribe(
      data => {
        this.parentCategoryList = data;
      });
  }
  GetCategoryList() {
    this.categoryService.GetCategoryListUnderParent().subscribe(
      data => {
        this.categoryList = data;
      });
  }
  GetSystemSettingFirstOrDefault() {
    this.categoryService.GetSystemSettingFirstOrDefault().subscribe(
      data => {
        this.websiteName = data.siteUrl;
      });
  }

  uploadTinyImage(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("TinyImage", this.fileToUpload);
    ////Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.selectedTinyImage = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  uploadSmallImage(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("SmallImage", this.fileToUpload);
    //Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.selectedSmallImage = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  uploadLargeImage(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("LargeImage", this.fileToUpload);
    //Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.selectedLargeImage = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  onTextChange(Value: string) {
    var i = 0, strLength = Value.length;
    for (i; i < strLength; i++) {
      Value = Value.replace(" ", "-");
    }
    this.category.url = Value.toLowerCase();
  }
  OnFocusOut() {
    if (this.category.categoryName.length > 0) {
      this.duplicateCategory = this.category.categoryName;
      // passing model instead of parameters due to special charactors issue in paramater 'categoryName'
      let categoryParams = new DisplayCategory();
      categoryParams.categoryID = this.category.categoryID;
      categoryParams.categoryName = this.category.categoryName;
      categoryParams.parentCategoryID = this.category.parentCategoryID;
      this.categoryService.CheckCategoryNameExists(categoryParams).subscribe(
        data => {
          if (data == true) {
            this.isCategoryExist = true;
            this.category.categoryName = "";
            this.category.url = "";
          } else {
            this.isCategoryExist = false;
          }
        });
    }
  }

  onSubmit() {
    this.fd.append("Id", this.category.id);
    this.fd.append("CategoryID", this.category.categoryID.toString());
    this.fd.append("CategoryName", this.category.categoryName);
    this.fd.append("IconClass", this.category.iconClass);
    this.fd.append("IsActive", this.category.isActive.toString());
    this.fd.append("IsShow", this.category.isShow.toString());
    this.fd.append("Url", this.category.url);
    //this.fd.append("Detail", this.category.detail);
    this.fd.append("TinyImage", this.category.tinyImage);
    this.fd.append("SmallImage", this.category.smallImage);
    this.fd.append("LargeImage", this.category.largeImage);
    this.fd.append("CreatedDate", this.category.createdDate.toString());
    this.fd.append("ParentCategoryID", this.category.parentCategoryID.toString());
    this.fd.append("JustForU", this.category.justForU.toString());
    //this.fd.append("SortOrder", this.category.sortOrder.toString());
    if (this.htmlContent != null) {
      this.fd.append("Detail", this.htmlContent);
    } else {
      this.fd.append("Detail", "");
    }
    if (this.htmlContent != null) {
      this.fd.append("MetaTitle", this.category.metaTitle);
    }
    else {
      this.fd.append("MetaTitle", "");
    }
    if (this.htmlContent != null) {
      this.fd.append("MetaTag", this.category.metaTag);
    } else {
      this.fd.append("MetaTag", "");
    }
    if (this.htmlContent != null) {
      this.fd.append("MetaDescription", this.category.metaDescription);
    } else {
      this.fd.append("MetaDescription", "");
    }

    // decide if current saved category is "category" or "subcategory"
    let IsCategory = this.parentCategoryList.filter(item => item.categoryID == this.category.parentCategoryID).length > 0;
    let IsSubCategory = this.categoryList.filter(item => item.categoryID == this.category.parentCategoryID).length > 0;
    if (this.category.parentCategoryID == 0 || (IsCategory == true && IsSubCategory == false)) {
      this.category.isParent = true;
    } else if (IsCategory == false && IsSubCategory == true) {
      this.category.isParent = false;
    }
    this.fd.append("IsParent", this.category.isParent.toString());
    this.toastr.success('Category updated successfully.', 'Success');
    this.categoryService.AddParentCategory(this.fd);
  }
}



// WEBPACK FOOTER //
// ./src/app/category-components/parent-category/edit-parent-category/edit-parent-category.component.ts